// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"232":"locale-ko-js","435":"locale-en-js"}[chunkId] + "." + {"232":"0e2abe5a","435":"19c3bbf2"}[chunkId] + ".js";
};